<template>
    <div class="user_grzx no-trans" v-loading="loading">
       <grzx ref="grzx" v-if="grzs_show==1" :user_info="user_info"></grzx>
       <grzxls ref="grzxls" v-if="grzs_show==2" :user_info="user_info"></grzxls>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 
import grzx from '@/components/user_grzx/user_grzx.vue'//普通个人中心
import grzxls from '@/components/user_grzx/user_grzx_ls.vue'//律师个人中心


export default {
    components: {
        grzx,
        grzxls,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            grzs_show:0,
            user_info:{},
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_user()
    },
    methods: {
        get_user(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                   if(res.data.type==2||res.data.type==3){
                    this.grzs_show=2
                   }else{
                    this.grzs_show=1
                   }
                   this.user_info=res.data
                } else {
                    alertErr(res.msg)
                    if(res.msg=='请登录'){
                        this.$router.push('/login')
                    }
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_grzx{
    
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_grzx.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
}
</style>
